import { getElement, getElements } from '../utils/functional';
import { Module } from './module/module'; // eslint-disable-next-line import/no-default-export

export default class _class extends Module {
  initialize() {
    this.setupListeners();
  }

  setupListeners() {
    getElements(this.selectors.option).forEach(option => {
      const stockStatus = () => {
        if (option.getAttribute('data-stock') < 4) {
          this.statusMessage.setAttribute(this.activeAttribute, 'false');
        } else {
          this.statusMessage.setAttribute(this.activeAttribute, 'true');
        }
      };

      this.listeners.add(option, 'click', stockStatus);
    });
  }

  get activeAttribute() {
    return 'aria-hidden';
  }

  get statusMessage() {
    return getElement('.prd-Status_Stock');
  }

}
_class.targets = ['option'];